import React, {useReducer} from 'react'

import LoginActions from '../../../../actions/LoginActions.js'
import reducer from '../../../../helpers/reducer.js'
import t from '../../../../helpers/Languages.js'

import {H5, P, Alert, Button} from '../../../../components/UI/index.js'
import {FormStack, Input} from '../../../../components/UI/forms/index.js'

interface SnelStartVerificationState {
    subscriptionKey: string
    clientKey: string
    loading: boolean
    requests: number
    error: string
}

const initialState = {
    subscriptionKey: '',
    clientKey: '',
    loading: false,
    requests: 0,
    error: ''
}

/** Makes the calls SnelStart needs to approve the koppeling of a reseller or customer, only for the Veloyd API Test reseller. */
export default function SnelStartVerification() {
    const [{subscriptionKey, clientKey, loading, requests, error}, dispatch] = useReducer<React.Reducer<SnelStartVerificationState, Partial<SnelStartVerificationState>>>(reducer, initialState)

    function onMakeRequests() {
        dispatch({loading: true, requests: 0, error: ''})

        LoginActions.makeSnelStartVerificationRequests(subscriptionKey, clientKey, (err, requests) => {
            if (err) {
                dispatch({loading: false, error: err})
            } else {
                dispatch({loading: false, requests})
            }
        })
    }

    return (
        <>
            <H5 style={{marginTop: 36, marginBottom: 24}}>{t('snelstartVerification')}</H5>
            <P style={{marginBottom: 24}}>{t('snelstartVerificationDescription')}</P>

            <FormStack>
                <Input
                    label={t('snelstartSubscriptionKey')}
                    value={subscriptionKey}
                    onChange={(event) => dispatch({subscriptionKey: event.target.value})}
                />

                <Input
                    label={t('snelstartClientKey')}
                    value={clientKey}
                    onChange={(event) => dispatch({clientKey: event.target.value})}
                />

                <Button
                    variant='text'
                    loading={loading}
                    disabled={!subscriptionKey || !clientKey}
                    onClick={onMakeRequests}
                >
                    {t('snelstartVerificationRequests')}
                </Button>

                {error && (
                    <Alert style={{marginBottom: 6}} onClose={() => dispatch({error: ''})} variant='error'>{error}</Alert>
                )}

                {!error && !!requests && (
                    <Alert style={{marginBottom: 6}} onClose={() => dispatch({requests: 0})}>{t('snelstartVerificationRequestsMade', requests)}</Alert>
                )}
            </FormStack>
        </>
    )
}
